import { PublicClientApplication } from "@azure/msal-browser";
import { loginRequest, msalConfig } from "../../configs/auth";
import AuthenticationError from "../../enums/authenticationError";
import store from "../../store";
import AuthenticationService from "./authenticationService";
import { setAuthentication } from "./authenticationHelpers";
export class MsalAuthenticationService extends AuthenticationService {
    constructor() {
        super();
        this.msal = new PublicClientApplication(msalConfig);
        this.initialize = async () => {
            var _a;
            try {
                const response = await this.msal.handleRedirectPromise();
                await this.handleResponse(response);
            }
            catch (error) {
                store.auth.setHasError(true);
                if ((_a = error.errorMessage) === null || _a === void 0 ? void 0 : _a.includes(AuthenticationError.NonexistentEmail))
                    this.signIn();
            }
            finally {
                store.auth.setIsAppLoading(false);
            }
        };
        this.signIn = () => {
            setAuthentication(this);
            this.msal.loginRedirect(loginRequest);
        };
        this.logOut = async () => {
            const logOutRequest = {
                account: this.msal.getAccountByUsername(store.auth.getCurrentUsername())
            };
            await this.msal.logoutRedirect(logOutRequest);
        };
        this.acquireUserToken = async (request) => {
            const account = this.msal.getAccountByUsername(store.auth.getCurrentUsername());
            request.scopes = loginRequest.scopes;
            if (!account) {
                await this.msal.logoutRedirect();
            }
            request.account = account;
            const { accessToken } = await this.msal.acquireTokenSilent(request);
            return accessToken;
        };
        this.handleResponse = async (response) => {
            if (response) {
                setAuthentication(this);
                await this.loginUserAndFetchAccessDetails(response.account);
                return;
            }
            const currentAccounts = this.msal.getAllAccounts();
            if (!currentAccounts || currentAccounts.length !== 1) {
                return;
            }
            setAuthentication(this);
            await this.loginUserAndFetchAccessDetails(currentAccounts[0]);
        };
        this.initialize();
    }
}
export default new MsalAuthenticationService();
